import {
  RESET_NOTEPAD,
  API_ERROR,
  GET_NOTEPAD,
  SET_NOTEPAD,
  UPDATE_NOTEPAD,
  UPDATE_NOTEPAD_SUCCESS,
  SET_NOTEPAD_CONTENT,
  TOGGLE_NOTEPAD,
} from "./actionTypes";

export const toggleNotepad = () => {
  return {
    type: TOGGLE_NOTEPAD,
    payload: {},
  };
};

export const resetNotepad = () => {
  return {
    type: RESET_NOTEPAD,
    payload: {},
  };
};
export const getNotepad = () => {
  return {
    type: GET_NOTEPAD,
    payload: {},
  };
};

export const loadNotepad = (data) => {
  return {
    type: SET_NOTEPAD,
    payload: { ...data },
  };
};

export const setNotepadContent = (content) => {
  return {
    type: SET_NOTEPAD_CONTENT,
    payload: content,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const updateNotepad = (notepadValues) => {
  return {
    type: UPDATE_NOTEPAD,
    payload: { notepadValues },
  };
};

export const updateNotepaduccess = (message) => {
  return {
    type: UPDATE_NOTEPAD_SUCCESS,
    payload: { message },
  };
};
